import { render, staticRenderFns } from "./MultiFileAttach.vue?vue&type=template&id=ef92f0f4&"
import script from "./MultiFileAttach.vue?vue&type=script&lang=js&"
export * from "./MultiFileAttach.vue?vue&type=script&lang=js&"
import style0 from "./MultiFileAttach.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports